<input id="fileToUpload" type="file" (change)="onChangefileToUpload($event)" style="display:none;">
<div class="display-flex">
  <div class="button-row">
    <button type="button" matTooltip="Ouvrir Document" *ngIf="!buttonDisabled" [disabled]="buttonDisabled" class="bet_time" mat-button
      color="primary" (click)="openDoc()">
      <mat-icon>local_library</mat-icon>
      <!-- <div>Ouvrir Document</div> -->
    </button>
  </div>
  <div class="button-row">
    <button type="button" matTooltip="Nouveau dossier" *ngIf="!buttonDisabled" [disabled]="buttonDisabled" class="bet_time" mat-button
      color="primary" (click)="crerDossier()">
      <mat-icon>create_new_folder</mat-icon>
      <!-- <div>Nouveau dossier</div> -->
    </button>
  </div>

  <div class="button-row">
    <button type="button" matTooltip="Ajouter fichier" *ngIf="!buttonDisabled" [disabled]="buttonDisabled" class="bet_time" mat-button
      color="primary" (click)="crerFichier()">
      <mat-icon>insert_drive_file</mat-icon>
      <!-- <div>Ajouter fichier</div> -->
    </button>
  </div>
  <div class="button-row">
    <button type="button" matTooltip="Renommer" *ngIf="!buttonDisabled" [disabled]="buttonDisabled" class="bet_time" mat-button color="primary"
      (click)="renommer()">
      <mat-icon> border_color</mat-icon>
      <!-- <div>Renommer</div> -->
    </button>
  </div>

  <div class="button-row">
    <button type="button" matTooltip="Télécharger" *ngIf="!buttonDisabled" [disabled]="buttonDisabled" class="bet_time" mat-button
      color="primary" (click)="telecharger()">
      <mat-icon>cloud_download</mat-icon>
      <!-- <div>Télécharger</div> -->
    </button>
  </div>
  <div class="button-row">
    <button type="button" matTooltip="Supprimer" *ngIf="!buttonDisabled" [disabled]="buttonDisabled" class="bet_time" mat-button color="primary"
      (click)="supprimer()">
      <mat-icon>delete</mat-icon>
      <!-- <div>Supprimer</div> -->
    </button>
  </div>
  <!-- <div class="button-row">
    <button type="button" matTooltip="Attacher action" [disabled]="buttonDisabled" mat-button color="primary"
      (click)="attacherAction()">
      <mat-icon>swap_horiz</mat-icon>
      <div>Attacher action</div>
    </button>
  </div> -->

</div>
<div *ngIf="exist;else attente"></div>
<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div id="documentColl" class="demo"></div>
<input id="fileToUpload" type="file" style="display:none;">